//Artigos.js

import React from 'react'
import { Text, View, StyleSheet } from 'react-native'
import styles from './Styles.js'

const Artigos = () => {
  return (
    <View style={styles.column}>
      <Text style={styles.titleText}>Artigos</Text>
      <Text></Text>
      <View style={styles.row}>
        <View style={styles.articlesColumnMobile}>
          <Text style={styles.titleText}>Carreiras públicas</Text>
          <Text style={styles.titleText}>Altos salários e estabilidade</Text>
          <Text style={styles.link}>Leia mais</Text>
          <Text> </Text>
        </View>
        <View style={styles.articlesColumnMobile}>
          <Text style={styles.titleText}>Cursos com maior taxa de terminantes da USP</Text>
          <Text style={styles.titleText}>Exatas, humanas e biológicas</Text>
          <Text style={styles.link}>Leia mais</Text>
          <Text> </Text>
        </View>
      </View>
      <Text> </Text>
    </View>
  )
};

export default Artigos;
